<template>
    <div class="table-responsive">
        <table class="ctable table-hover table-condensed table-striped" style="min-width:100%;line-height: 1em" id="midatatable">
            <thead style="background:#196391;">
                <tr class="white--text text-center">
                    <th>#</th>
                    <th>Responsable</th>
                    <th>Desde</th>
                    <th>Hasta</th>
                    <th>Registrado por</th>
                    <th>Opciones</th>
                </tr>
            </thead>

            <tbody>
                <tr v-for="(r,ind) in responsables" :key="ind">
                    <td> {{ind+1}} </td>
                    <td> {{r.encargado_cobranza.nombres}} {{r.encargado_cobranza.primer_apellido}} {{r.encargado_cobranza.segundo_apellido}} </td>
                    <td> {{parsefecha(r.fecha_inicio)}} </td>
                    <td> {{parsefecha(r.fecha_fin)}} </td>
                    <td> {{r.usuario_registro.nombres}} {{r.usuario_registro.primer_apellido}} {{r.usuario_registro.segundo_apellido}} </td>
                    <td> </td>
                </tr>
            </tbody>
        </table>

        <div class="text-center">
            <div style="display: inline-block;" v-show="loading" class="loader"></div>
        </div>
    </div>
</template>

<script>
import axios from "axios";

export default {
    data() {
        return {
            responsables: [],
            loading: false,
        };
    },
    watch: {},
    components: {},
    methods: {
        obtenerasignaciones(gestion, mes, programa) {
            window.console.log(gestion, mes, programa);
            this.getcobradores(programa);
            this.$emit("dataloaded");
        },
        parsefecha(f){
            if( !f ) return '';
            let fs = f.split('-');
            return `${fs[2]}/${fs[1]}/${fs[0]}`
        },
        getcobradores(programa){
            const vue = this;
            const url = `${process.env.VUE_APP_API_REST}/api/v1/asignacion/programa-directa/${programa.id}`;
            vue.loading = true;
            this.responsables = [];
            axios
                .get(url)
                .then((res) => {
                    window.console.log(res);
                    if( res.data ){
                        vue.responsables = res.data.data;
                    }
                    vue.loading = false;
                })
                .catch((error) => {
                    window.console.log(error);
                    vue.loading = false;
                });
        }
    },
    mounted() {},
};
</script>
